export const PRESCRIPTION_TOTAL_GET_REQUESTED = 'PRESCRIPTION_TOTAL_GET_REQUESTED';
export const PRESCRIPTION_TOTAL_GET_SUCCEED = 'PRESCRIPTION_TOTAL_GET_SUCCEED';
export const PRESCRIPTION_TOTAL_GET_FAILED = 'PRESCRIPTION_TOTAL_GET_FAILED';

export const PRESCRIPTIONS_GET_REQUESTED = 'PRESCRIPTIONS_GET_REQUESTED';
export const PRESCRIPTIONS_GET_SUCCEED = 'PRESCRIPTIONS_GET_SUCCEED';
export const PRESCRIPTIONS_GET_FAILED = 'PRESCRIPTIONS_GET_FAILED';
